// Slice-10 permission-catalogue browser.

import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../api/client";
import { useI18n } from "../i18n/I18nContext";

export function PermissionsScreen(): JSX.Element {
  const { t } = useI18n();
  const query = useQuery({
    queryKey: ["permissions", "catalogue"],
    queryFn: async () => {
      const response = await apiClient.GET("/identity/permissions", {});
      if (!response.data) {
        throw new Error("permissions_fetch_failed");
      }
      return response.data;
    },
  });

  return (
    <div>
      <h1>{t("permissions.heading")}</h1>
      {query.isLoading && <p>{t("login.discovering")}</p>}
      {query.isError && (
        <p role="alert" style={{ color: "var(--rc-color-danger)" }}>
          {(query.error as Error).message}
        </p>
      )}
      {query.data && query.data.items.length === 0 && <p>{t("permissions.empty")}</p>}
      {query.data && query.data.items.length > 0 && (
        <table className="rc-table">
          <thead>
            <tr>
              <th>{t("permissions.column.name")}</th>
              <th>{t("permissions.column.bucket")}</th>
              <th>{t("permissions.column.displayName")}</th>
              <th>{t("permissions.column.advanced")}</th>
            </tr>
          </thead>
          <tbody>
            {query.data.items.map((perm) => (
              <tr key={perm.name}>
                <td><code>{perm.name}</code></td>
                <td>{perm.bucket}</td>
                <td>{perm.display_name}</td>
                <td>{perm.is_advanced ? "✔︎" : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
